module.exports = __webpack_public_path__ + "img/weck_aeby_logo.d04c9038.png";